<script lang="ts">
  import PubSub from 'pubsub-js'
  import { onMount, type Component } from 'svelte'
  import { isLoading, lang } from '@/store'
  import { axiosInstance } from '@/plugins/axios'
  import { i18n, showErrorMessage } from '@/plugins/util'
  import { enquiryResult } from '@/components/appDriver/store'
  import PageHome from '@/components/appDriver/PageHome.svelte'
  import axios from 'axios'

  let component: Component

  // ================================================================================

  PubSub.subscribe('DRIVER.CHANGE_PAGE', (msg, data) => {
    component = data.component
  })

  // ================================================================================

  onMount(() => {
    enquiry()
  })

  async function enquiry() {
    try {
      $isLoading = true
      const { data } = await axiosInstance.get('/webapp/driver/enquiry')

      $enquiryResult = {
        user: {
          uuid: data['user']['uuid'],
          name: data['user']['name'],
          profileImage: data['user']['profile_image'],
          gender: data['user']['gender'],
          dob: data['user']['dob'],
          averageRating: data['user']['average_rating'],
          registeredAt: data['user']['registered_at'],
          lifeTimeHours: data['user']['life_time_hours'],
          vehicleBrand: data['user']['vehicle_brand'],
          vehicleModel: data['user']['vehicle_model'],
          vehicleImage: data['user']['vehicle_image'],
          vehiclePlateNo: data['user']['vehicle_plate_no'],
          lastAppointmentInvoiceTotal: data['user']['last_appointment_invoice_total'],
          lastAppointmentBookingId: data['user']['last_appointment_booking_id'],
        },
        paymentChannels: data['payment_channels'],
      }

      component = PageHome

      $isLoading = false
    } catch (error) {
      $isLoading = false

      if (axios.isAxiosError(error)) {
        if (error.response) {
          showErrorMessage(error.response.data.message)
        } else if (error.request) {
          showErrorMessage(i18n($lang, ['Cannot connect to server, please try again', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບ ກະລຸນາລອງໃໝ່']))
        } else {
          showErrorMessage(i18n($lang, ['Please try again', 'ກະລຸນາລອງໃໝ່']))
        }
      } else {
        showErrorMessage(i18n($lang, ['Please try again', 'ກະລຸນາລອງໃໝ່']))
      }

    }
  }
</script>

<svelte:head>
  <title>Driver Center</title>
</svelte:head>

<svelte:component this={component} />
